import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "h-80vh" }
const _hoisted_2 = { class: "d-table" }
const _hoisted_3 = { class: "d-table-cell" }
const _hoisted_4 = {
  class: "card border-0 box-shadow border-radius-10 mb-4 w-100",
  style: {"max-width":"500px","margin":"auto"}
}
const _hoisted_5 = { class: "card-body p-30" }
const _hoisted_6 = { class: "text-center mb-4" }
const _hoisted_7 = {
  key: 0,
  class: "fs-18 fw-semibold mb-2 text-danger"
}

import { ref } from "vue"
import type { ApiResult, ForgotPassword } from "@/types/auth"
import { useAuthStore } from '@/stores/auth'
import { storeToRefs } from "pinia"
import { useRouter } from 'vue-router'
import Swal from "sweetalert2"


export default /*@__PURE__*/_defineComponent({
  __name: 'ForgetPassword',
  setup(__props) {

const { forgotPassword } = useAuthStore()
const { error } = storeToRefs(useAuthStore())
const router = useRouter()

const state = ref<ForgotPassword>({
  email: ""
})

const login = async () => {
  const response: ApiResult = await forgotPassword(state.value)

  if (response.success) {
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'success',
      title: 'Password was reset successfully',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true
    })
    router.push("/")
  }


}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[0] || (_cache[0] = _createElementVNode("h4", { class: "fs-20 fw-semibold mb-2" }, "Forgot Your Password", -1)),
              (!!_unref(error))
                ? (_openBlock(), _createElementBlock("h5", _hoisted_7, _toDisplayString(_unref(error)), 1))
                : _createCommentVNode("", true),
              _cache[1] || (_cache[1] = _createElementVNode("p", { class: "fs-14 text-body" }, " Enter the email address you used when you joined and we’ll send you instructions to reset your password ", -1))
            ]),
            _createElementVNode("form", null, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "form-group mb-4" }, [
                _createElementVNode("label", { class: "label" }, "Email Address"),
                _createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  placeholder: "Enter email address"
                })
              ], -1)),
              _createElementVNode("div", { class: "form-group" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "default-btn w-100 d-block",
                  onClick: login
                }, " Send ")
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})